import * as Sentry from '@sentry/browser';
import { getCookieUin, getCookieUid } from '@tencent/tencent-doc-report';
import { CUSTOM, IS_PRIVATE_WECOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { getCommonExtData } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/common-ext-data';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

// 可忽略的上报
const ignoreErrors = [
    'ResizeObserver loop limit exceeded', // dui Dropdown组件bug，对使用无影响（https://exchangetuts.com/resizeobserver-loop-limit-exceeded-1639479845583539），暂时忽略
];

const DATE_LENGTH = 14; // global.__globalReleaseVersion的格式为'bugfix-xxx_123456789_1dc18a1d_20240805-1434'，最后14位是时间
const releaseVersion = global.__globalReleaseVersion?.replace(/\//g, '-').slice(0, -DATE_LENGTH);
const environment = global.__DWS_INFO__?.curEnvId || 'unknown';

export default function (options: { appEntryType: AppEntryType }): void {
    if (process.env.NODE_ENV !== 'production' || IS_PRIVATE_WECOM || getCacConfigByKey('custom.common.disableSentry', false)) {
        return;
    }
    // Sentry 初始化
    Sentry.init({
        dsn: CUSTOM.SENTRY.DSN,
        // branchName_commitHash 与sentry-cli的release配置相同，保证source-map正确 oci/node-scripts/upload-sourcemap.sh
        release: releaseVersion,
        environment,
        ignoreErrors,
        // 采样率，对齐其他品类
        sampleRate: 0.1,
        beforeSend: (event) => {
            // fix 分支不做上报
            if (releaseVersion?.startsWith('fix-')) {
                return null;
            }
            return event;
        },
        maxBreadcrumbs: 0,
    });

    Sentry.configureScope((scope) => {
        scope.setUser({ uin: getCookieUin() });
        const uid = getCookieUid();
        uid && scope.setTag('uid', uid);
        // 基础标签补充
        const extData = getCommonExtData({ appEntryType: options.appEntryType });
        Object.keys(extData).forEach((p) => {
            scope.setTag(p, extData[p]);
        });
    });
}

